import styled from 'styled-components';
import { primitives } from '@veneer/primitives';
const { color, typography, layout } = primitives;

export const PlanContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 14px;
  color: ${color.gray12};
`;

export const SubtitleSection = styled.div`
  background-color: ${color.electricBlue0};
  border-radius: ${layout.cornerRadius2}px;
  padding: 8px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const SubtitleIcon = styled.div`
  color: ${color.electricBlue7};
`;

export const CurrentPlanInfo = styled.p`
  font-family: ${typography.family0};
  color: ${color.gray12};
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
  margin: 0 0 4px 0;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const RolloverSection = styled.div`
  background-color: transparent;
  border: 1px solid ${color.gray3};
  border-radius: ${layout.cornerRadius2}px;
  padding: 16px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
`;

export const RolloverIcon = styled.div`
  padding: ${layout.size2}px;
  margin: 10px 0;
  background-color: ${color.electricBlue0};
  border-radius: ${layout.cornerRadius2}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RolloverText = styled.p`
  font-family: ${typography.family0};
  color: ${color.gray12};
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
  margin: 0 0 4px 0;
`;

export const RolloverPages = styled.div`
  font-family: ${typography.family0};
  color: ${color.gray12};
  font-size: ${typography.size2};
  font-weight: ${typography.weight6};
  line-height: ${typography.size4};
  margin: 0;
`;

export const SectionTitle = styled.h2`
  font-family: ${typography.family0};
  color: ${color.black};
  font-size: ${typography.size5};
  line-height: ${typography.lineHeight3};
  font-weight: ${typography.weight4};
  margin-bottom: 20px;
  @media (max-width: ${layout.breakpoint1}px) {
    font-size: ${typography.size3};
  }
`;

export const PlanCard = styled.div`
  border: 1px solid ${color.gray3};
  border-radius: ${layout.cornerRadius2}px;
  background-color: ${color.white};
  overflow: hidden;
`;

export const PlanHeader = styled.div`
  background-color: ${color.electricBlue2};
  height: 20px;
`;

export const PlanContent = styled.div`
  padding: 24px;
`;

export const PlanIcon = styled.div`
  margin: 10px 0px 10px 0px;
  display: flex;
  > img {
    width: 60px;
    height: 41px;
  }
`;

export const PlanItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const PlanDetails = styled.div`
  flex: 1;
`;

export const PlanName = styled.h3`
  font-family: ${typography.family0};
  color: ${color.gray12};
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
  font-weight: ${typography.weight4};
  margin: 0 0 4px 0;
`;

export const PlanPages = styled.p`
  font-family: ${typography.family0};
  color: ${color.gray7};
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
  margin: 0;
`;

export const PlanPrice = styled.div`
  font-family: ${typography.family0};
  color: ${color.gray12};
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
  font-weight: ${typography.weight3};
  text-align: right;
  margin-bottom: 4px;
`;

export const PlanBadge = styled.div`
  color: ${color.green8};
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
  font-weight: ${typography.weight3};
  text-align: center;
`;

export const InfoSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${layout.size3}px;
  margin-bottom: ${layout.size5}px;
  padding: ${layout.size2}px ${layout.size6}px;
  background-color: ${color.electricBlue0};
  border-radius: ${layout.cornerRadius2}px;
`;

export const InfoIcon = styled.div`
  color: ${color.electricBlue7};
  margin-top: ${layout.size1}px;
`;

export const InfoText = styled.p`
  font-family: ${typography.family0};
  color: ${color.gray12};
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight1};
  margin: 0;
`;

export const PricingSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-top: 1px solid ${color.gray6};
  border-bottom: 1px solid ${color.gray6};
  padding: 12px 0;
`;

export const PriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: ${layout.size4}px;
  font-weight: ${typography.weight3};
`;

export const PriceLabel = styled.span`
  font-family: ${typography.family0};
  color: ${color.gray12};
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
`;

export const PriceValue = styled.span`
  font-family: ${typography.family0};
  color: ${color.gray12};
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
`;
